// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum ErrorIssueStatus {
	Unresolved = 0,
	Resolved = 1,
	Ignored = 2,
	Regressed = 3,
}

export const ErrorIssueStatusDisplayNames: { [key in keyof typeof ErrorIssueStatus]?: string} = {
	"Unresolved": "Unresolved",
	0 : "Unresolved",
	"Resolved": "Resolved",
	1 : "Resolved",
	"Ignored": "Ignored",
	2 : "Ignored",
	"Regressed": "Regressed",
	3 : "Regressed",
}

export const getErrorIssueStatusDisplayName = (key: ErrorIssueStatus | (keyof typeof ErrorIssueStatus & string)) => {
	return ErrorIssueStatusDisplayNames[key];
}

